import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

defineComponent({
  tag: "oc-card-v3",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./CardV3.global.scss?inline"),
  props: {
    elevationLevel: { type: "String", attribute: "elevation-level", reflect: true },
    inverted: { type: "Boolean", reflect: true, default: false },
    size: { type: "String", reflect: true },
  },
  html: "<slot part='overflow-for-elevation'></slot><slot name='content' part='overflow-for-elevation'></slot>",
});
